<template>
	<div class="pressResources_container">
		<div class="content_item">
			<div class="title">1.Authorization Agreement</div>
			<div class="content">
				Given the diverse operating environments and website architectures used by different journals, journal
				staff
				may
				encounter obstacles when installing the plugin. To simplify the process, we offer an easy solution: by
				signing
				the relevant agreement to authorize Contrimetric to access the journal server account within a specified
				period,
				we can provide one-stop installation assistance.
				Please send your journal details and preferred installation time to <a
					href="mailto:contact@contrimetric.com">contact@contrimetric.com</a>. We will
				contact
				you promptly. Click the link below to download the agreement, sign and stamp it, then return the stamped
				copy to
				the same email address. The installation will be completed at the scheduled time.
			</div>
			<div class="down" @click="downloadFile('General Server Access Authorization Agreement.docx')">
				<img src="../../assets/images/WORD.png" alt="">
				<span>General Server Access Authorization Agreement.docx</span>
			</div>
		</div>
		<div class="content_item">
			<div class="title">
				2.Agreement for Use of Contrimetric Widget
			</div>
			<div class="content">
				To ensure clarity and compliance of responsibilities for both parties involved, please download and
				review the
				Agreement for Use of Contrimetric Widget.
			</div>
			<div class="down" @click="downloadFile('Agreement for Use of Contrimetric Widget.docx')">
				<img src="../../assets/images/WORD.png" alt="">
				<span>Agreement for Use of Contrimetric Widget.docx</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		downloadFile(fileName) {
			window.open(`https://contrimetric.com/logo/curriculum_vitae/${fileName}`, '_blank')
		}
	}
}
</script>

<style lang="scss">
.pressResources_container {
	margin: 50px 0;
	margin-bottom: 300px;
	display: flex;
	flex-direction: column;
	gap: 30px;

	.content_item {
		display: flex;
		flex-direction: column;
		gap: 10px;

		.title {
			font-size: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 16px;
			line-height: 1.5;
		}

		.down {
			display: flex;
			align-items: center;
			gap: 10px;
			transition: all 0.3s;

			&:hover {
				cursor: pointer;
				text-decoration: underline;
			}

			img {
				width: 25px;
				height: 25px;
			}
		}
	}
}
</style>